import { makeStyles } from '@admitkard/ccl';

export default makeStyles((theme) => ({
  root :{
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    marginBottom : '4rem',
    '& *'  : {
      boxSizing: 'border-box',
    },
  },

  ['@global']: {
    // Global styles here
    html :{
      fontSize : '16px !important',
    },
  },

  blogHomeContainer : {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent:'center',
    width:'100%',
    '@media screen and (min-width: 480px)' : {
      maxWidth: '28.775rem',
      padding:'0rem'
    },
    '@media screen and (min-width: 576px)' : {
      maxWidth: '32rem',
    },
    '@media screen and (min-width: 768px)' : {
      maxWidth: '42rem',
    },
    '@media screen and (min-width: 990px)' : {
      maxWidth: '55rem',
    },
    '@media screen and (min-width: 1250px)' : {
      maxWidth: '65rem',
    },
    '@media screen and (min-width: 1450px)' : {
      maxWidth: '75rem',
    }
  },
  blogsHomeHeaderSec : {
    '& *'  : {
      boxSizing: 'border-box',
      margin:'0px',
      padding:'0px',
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent:'flex-start',
    padding: '0px 1rem',
    width:'100%',
  },
  blogsHeaderTitle : {
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '1.25rem',
    lineHeight: '1.875rem',
    textAlign: 'center',
    color: '#483287',
    marginTop:'1.25rem',
    width:'100%',
    '@media screen and (min-width: 768px)' : {
      fontSize: '2rem',
      lineHeight: '3rem',
      marginTop:'2rem',
    }
  },
  blogsHeaderSubTitle:{
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: '1.3125rem',
    color: '#483287',
    marginTop:'0.5rem',
    width:'100%',
    textAlign: 'center',
    '@media screen and (min-width: 768px)' : {
      fontSize: '1.25rem',
      lineHeight: '1.875rem',
    },
  },
  blogHomeBanner : {
    marginTop:'2.5rem',
    width:'100%',
    overflow:'hidden',
  },
  blogHomeBannerSecond:{
    marginTop:'4rem',
    width:'100%',
  },
  blogsLatestArticle :{
    margin: '0rem 1rem',
    width:'90%',
    marginTop: '2rem',
    '@media screen and (min-width: 768px)' : {
      margin: '0rem',
      width:'100%',
      marginTop: '4rem',
    },
  },
  latestArticlesTitle:{
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '1.5rem',
    lineHeight: '2rem',
    marginBottom:'0rem',
    color: '#483287',
    '@media screen and (min-width: 768px)' : {
      fontSize: '2rem',
      lineHeight: '3rem',
    }
  },
  blogHomeExploreSec :{
    width:'100%',
    padding:'0rem 1rem',
    '& *'  : {
      boxSizing: 'border-box',
      margin:'0px',
      padding:'0px',
    },
    margin: '0rem 1rem',
    '& h1':{
      display:'none',
    },
    // not to repeated anywhere else, used to avoid creating duplicate component
    '& > div > div' :{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(361px, 100%))',
      gap: 'clamp(1rem, 1vw, 1rem)',
      justifyContent: 'center',
      '@media screen and (min-width: 768px)' : {
        gap: 'clamp(.25rem, 1vw, 0.5rem)',
      },
      '@media screen and (min-width: 992px)' : {
        gridTemplateColumns: 'repeat(auto-fit, minmax(361px, 49.5%))',
      },
      '@media screen and (min-width: 1450px)' : {
        gridTemplateColumns: 'repeat(auto-fit, minmax(361px, 49.667%))',
      }
    },
    '& > div > div > div' :{
      margin :'0rem',
    },
    '@media screen and (min-width: 768px)' : {
      padding:'0rem',
      width:'100%',
      margin: '0rem',
    },
  },
  missedArticleTitle:{
    marginTop:'2rem',
    marginBottom:'1rem',
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '1.5rem',
    lineHeight: '2rem',
    textTransform: 'capitalize',
    color: '#483287',
    width:'100%',
    textAlign: 'start',
    '@media screen and (min-width: 768px)' : {
      fontSize: '2rem',
      lineHeight: '3rem',
      marginTop:'4rem',
    }
  },
  exploreSecTitle:{
    marginTop:'2rem',
    marginBottom:'1rem',
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '1.5rem',
    lineHeight: '2rem',
    textTransform: 'capitalize',
    color: '#483287',
    width:'100%',
    textAlign: 'start',
    '@media screen and (min-width: 768px)' : {
      fontSize: '2rem',
      lineHeight: '3rem',
      marginTop:'4rem',
    }
  },
  contributorSection :{
    margin: '0rem 1rem',
    width:'90%',
    '@media screen and (min-width: 768px)' : {
      margin: '0rem',
      width:'100%',
    },
  },
  contributorList:{
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  contributorSecTitle:{
    marginTop:'2rem',
    marginBottom:'0px',
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '1.5rem',
    lineHeight: '2rem',
    textTransform: 'capitalize',
    color: '#483287',
    width:'100%',
    textAlign: 'start',
    '@media screen and (min-width: 768px)' : {
      fontSize: '2rem',
      lineHeight: '3rem',
      marginTop:'4rem',
    }
  },
  blogSubscribeSec : {
    width:'100%',
    padding: '1rem',
    background: '#F7EFFF',
    '@media screen and (min-width: 472px)' : {
      borderRadius: '1.5rem',
    },
    '@media screen and (min-width: 768px)' : {
      padding:'0rem',
      marginTop: '4rem',
      borderRadius: '1.75rem',
    },
  },
  blogTopCategoriesSec:{
    margin: '2rem 1rem 0rem 1rem',
    width:'90%',
    '@media screen and (min-width: 768px)' : {
      margin: '4rem 0rem 0rem 0rem',
      width:'100%',
    },
  },
  blogWebStorySec:{
    margin: '0rem 1rem',
    width:'90%',
    '@media screen and (min-width: 768px)' : {
      margin: '0rem',
      width:'100%',
      marginTop:'2rem',
    }
  },
  webStoriesTitle:{
    marginTop:'2rem',
    marginBottom:'1rem',
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '1.5rem',
    lineHeight: '2rem',
    textTransform: 'capitalize',
    color: '#483287',
    textAlign: 'start',
    '@media screen and (min-width: 768px)' : {
      fontSize: '2rem',
      lineHeight: '3rem',
    },
  },
  blogBreadcrumbsContainer: {
    alignSelf: 'flex-start',
    padding: theme.spacing(1),
  },
  headerWebStories: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  blogLinkViewAll: {
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '1rem',
    lineHeight: '1.5rem',
    color: '#483287',
    cursor:'pointer',
    '@media screen and (min-width: 768px)' : {
      fontSize: '1.25rem',
      lineHeight: '1.875rem',
    },
  }
}),{name: 'HomeBlog'});
